import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import React, { ReactNode } from 'react';
import { IconButtonLink } from '../base/IconButtonLink';

export interface RowActionMuiProps extends Omit<
  IconButtonProps,
  'onClick' | 'children' | 'size' | 'color' | 'title'
> {
  onClick?: () => void;
  title?: React.ReactNode;
  icon?: React.ReactNode;
  children?: ReactNode;
  link?: string;
  size?: IconButtonProps['size'];
  color?: IconButtonProps['color'];
}

export function RowActionMui({
  onClick,
  title,
  icon,
  children,
  link,
  size = 'small',
  color = 'primary',
  ...rest
}: RowActionMuiProps) {
  const buttonContent = children || icon || null;

  const buttonProps = {
    size,
    color,
    ...rest,
  };

  if (link) {
    return (
      <Tooltip title={title as React.ReactNode} placement="top">
        <IconButtonLink to={link} openInNewTab {...buttonProps}>
          {buttonContent}
        </IconButtonLink>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={title as React.ReactNode} placement="top">
      <IconButton onClick={onClick} {...buttonProps}>
        {buttonContent}
      </IconButton>
    </Tooltip>
  );
}
